import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumCaseLabelWeightType implements BaseEnumType {
  private static allValues: EnumCaseLabelWeightType[] = []; // make sure this is top-most
  
  public static export = new EnumCaseLabelWeightType(69, "Export", "enum_case_label_weight_type_export");
  public static none = new EnumCaseLabelWeightType(78, "None", "enum_case_label_weight_type_none");
  public static standard = new EnumCaseLabelWeightType(83, "Standard", "enum_case_label_weight_type_standard");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumCaseLabelWeightType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isExport() { return this === EnumCaseLabelWeightType.export; }
  public isNone() { return this === EnumCaseLabelWeightType.none; }
  public isStandard() { return this === EnumCaseLabelWeightType.standard; }

  public static getValues(): readonly EnumCaseLabelWeightType[] {
    return EnumCaseLabelWeightType.allValues;
  }

  public static getValuesExcept0(): readonly EnumCaseLabelWeightType[] {
    return EnumCaseLabelWeightType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumCaseLabelWeightType {
    const found = EnumCaseLabelWeightType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumCaseLabelWeightType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumCaseLabelWeightType): EnumCaseLabelWeightType {
    const found = name ? EnumCaseLabelWeightType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumCaseLabelWeightType - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumCaseLabelWeightType>): boolean {
    return this.key === other?.key;
  }
}